// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      // eslint-disable-next-line
      inventoryTypeOptions: [
        "C",
        "O",
        "P",
        "M"
      ],
      inventoryOwnerOptions: [
        "S", // site
        "J",
        "M",
        "P"
      ],
      inventoryThemeOptions: [
        "C0", // site
        "C1",
        "C2",
        "C3"
      ],
      inventoryHazardOptions: [
        "H0", // site
        "H1",
        "H2",
        "H3"
      ]
    };
  }
};
